<template>
    <div class="gauge_config chartConfig_viewDP">
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til">总数</span>
            <el-input v-model="config.gauge.total" @change="getChange" type="number" min="0"></el-input>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">半径大小</span>
            <el-input v-model="config.gauge.radius" @change="getRender" type="number" min="0"></el-input>
            <div class="unit">%</div>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">起始角度</span>
            <el-input v-model="config.gauge.startAngle" @change="getRender" type="number"></el-input>
            <div class="unit">度</div>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">结束角度</span>
            <el-input v-model="config.gauge.endAngle" @change="getRender" type="number" min="-360"></el-input>
            <div class="unit">度</div>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til">分割段数</span>
            <el-input v-model="config.gauge.splitNumber" @change="getRender" type="number" min="0"></el-input>
        </div>

        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.gauge.splitLine.show" @change="getRender">是否显示分隔线</el-checkbox>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til span_tilMax">分隔线线长</span>
            <el-input v-model="config.gauge.splitLine.length" @change="getChange" type="number" min="0"></el-input>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til span_tilMax">分隔线颜色</span>
            <el-color-picker v-model="config.gauge.splitLine.lineStyle.color" show-alpha
                             @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til">分隔线宽</span>
            <el-input v-model="config.gauge.splitLine.lineStyle.width" @change="getChange" type="number"
                      min="0"></el-input>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til span_tilMax">分隔线类型</span>
            <el-select v-model="config.gauge.splitLine.lineStyle.type" placeholder="请选择标记的图形"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in lineList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.gauge.axisLine.show" @change="getRender">是否显示仪表盘轴线</el-checkbox>
        </div>
        <div class="chartDivConfig numViewConfig">
            <span class="span_til">轴线宽度</span>
            <el-input v-model="config.gauge.axisLine.lineStyle.width" @change="getChange" type="number"
                      min="0"></el-input>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.gauge.axisTick.show" @change="getRender">是否显示刻度</el-checkbox>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til">刻度数</span>
            <el-input v-model="config.gauge.axisTick.splitNumber" @change="getChange" type="number" min="0"></el-input>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til">刻度线长</span>
            <el-input v-model="config.gauge.axisTick.length" @change="getChange" type="number" min="0"></el-input>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til span_tilMax">刻度线颜色</span>
            <el-color-picker v-model="config.gauge.axisTick.lineStyle.color" show-alpha
                             @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til">刻度线宽</span>
            <el-input v-model="config.gauge.axisTick.lineStyle.width" @change="getChange" type="number"
                      min="0"></el-input>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til span_tilMax">刻度线类型</span>
            <el-select v-model="config.gauge.axisTick.lineStyle.type" placeholder="请选择标记的图形"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in lineList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.gauge.axisLabel.show" @change="getRender">是否显示标签</el-checkbox>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til span_tilMax">与刻度线距离</span>
            <el-input v-model="config.gauge.axisLabel.distance" @change="getChange" type="number" min="0"></el-input>
        </div>

        <div class="chartDivConfig colViewConfig">
            <span class="span_til span_tilMax">刻度文字颜色</span>
            <el-color-picker v-model="config.gauge.axisLabel.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til span_tilMax">刻度文字大小</span>
            <el-input v-model="config.gauge.axisLabel.fontSize" @change="getChange" type="number" min="0"></el-input>
        </div>

        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.gauge.pointer.show" @change="getRender">是否显示指针</el-checkbox>
        </div>

        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">指针长度</span>
            <el-input v-model="config.gauge.pointer.length" @change="getRender" type="number"></el-input>
            <div class="unit">%</div>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til">指针宽度</span>
            <el-input v-model="config.gauge.pointer.width" @change="getChange" type="number" min="0"></el-input>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">指针颜色</span>
            <el-color-picker v-model="config.gauge.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.gauge.title.show" @change="getRender">是否显示标题</el-checkbox>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til">标题文字大小</span>
            <el-input v-model="config.gauge.title.textStyle.fontSize" @change="getChange" type="number" min="0"></el-input>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">标题颜色</span>
            <el-color-picker v-model="config.gauge.title.textStyle.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig">
            <span class="span_til">标题位置</span>
            <el-input v-model="config.gauge.title.offsetCenter[1]" @change="getChange" type="number" ></el-input>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.gauge.detail.show" @change="getRender">是否显示数值</el-checkbox>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til">数值文字大小</span>
            <el-input v-model="config.gauge.detail.fontSize" @change="getChange" type="number" min="0"></el-input>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">数值颜色</span>
            <el-color-picker v-model="config.gauge.detail.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig">
            <span class="span_til">数值位置</span>
            <el-input v-model="config.gauge.detail.offsetCenter[1]" @change="getChange" type="number" ></el-input>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */
    export default {
        name: 'gauge_config',
        components: {},
        props: {
            type: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                symbolList: [
                    {value: 'circle', label: '圆'},
                    {value: 'rect', label: '矩型'},
                    {value: 'roundRect', label: '圆矩型'},
                    {value: 'pin', label: '标记'},
                    {value: 'arrow', label: '箭头'},
                    {value: 'none', label: '空'},
                    {value: 'triangle', label: '三角形'},
                    {value: 'emptyCircle', label: '空心圆'},
                    {value: 'diamond', label: '菱形'}
                ],
                lineList: [
                    {value: 'solid', label: '实线'},
                    {value: 'dashed', label: '虚线'},
                    {value: 'dotted', label: '点线'},
                ]
            }
        },
        computed: {
            config() {

                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.params;
                }
            },
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
            getChange() {
                this.config.gauge.changeBool = true;
                this.getRender();
            }
        },
        mounted() {

        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    .gauge_config {
        .chartDivConfig {
            .span_til {
                width: 32%!important;
                max-width: 90px !important;
            }
        }
    }
</style>